import React from 'react';
import HeaderBottom from './HeaderBottom';
import ServicesSection from './ServicesSection';
import CallToAction from './CallToAction';

const ServicePage = () => {
    return (
        <div className="boxed_wrapper ltr">
            <HeaderBottom />
            <ServicesSection />
            <CallToAction />
        </div>
    );
};

export default ServicePage;
